const getRemSize = (): number =>
  parseFloat(getComputedStyle(document.documentElement).fontSize)

export { getRemSize }
